// Module
var code = "<span> <a :href=\"'tel:' + value\" class=\"phone\">{{ value }}</a> </span>";
// Exports
module.exports = code;